import axios from 'axios';
import { useFeature } from 'flagged';
import getHeaders from '../utils/getHeaders';
import { providerListEndpoint } from '../config';
import { logger } from '../logger';

const log = logger();

const getFeatureVersionSupport = async () => {
  try {
    const url = `${providerListEndpoint}/config/feature-flags`;
    const response = await axios.get(url, getHeaders());
    return response.data?.release ? response.data : null;
  } catch (err) {
    log.error('Error getting feature version support', err);
    return null;
  }
};

const getFeatureFlagConfig = async (
  providerId,
  professionalId,
  countryCode,
) => {
  try {
    const url = `${providerListEndpoint}/config/portal?professionalId=${professionalId}${
      providerId === null ? '' : `&providerId=${providerId}`
    }${countryCode ? `&countryCode=${countryCode}` : ''}`;
    const response = await axios.get(url, getHeaders());
    return response.data;
  } catch (err) {
    log.error('Error getting feature flag config', err);
    return null;
  }
};

const getFeatureFlags = () => {
  return {
    patientsMenu: useFeature('featureEnabler/patientsMenu'),
    createPatient: useFeature('featureEnabler/createPatient'),
    deviceRegistration: useFeature(
      'featureEnabler/deviceRegistration',
    ),
    serviceRequest: useFeature('featureEnabler/serviceRequest'),
    programFileRequests: useFeature(
      'featureEnabler/programFileRequests',
    ),
    clinicAdmin: useFeature('featureEnabler/clinicAdmin'),
    cliniciansSubMenu: useFeature('featureEnabler/cliniciansSubMenu'),
    remoteCheck: useFeature('featureEnabler/remoteCheck'),
    simpleSearch: useFeature('featureEnabler/simpleSearch'),
    advancedSearch: useFeature('featureEnabler/advancedSearch'),
    viewPatient: useFeature('featureEnabler/viewPatient'),
  };
};

const featureFlagService = {
  getFeatureFlagConfig,
  getFeatureFlags,
  getFeatureVersionSupport,
};

export default featureFlagService;
